module.exports = {
  GET_IATA_CODES_REQUEST: 'GET_IATA_CODES_REQUEST',
  GET_IATA_CODES_SUCCESS: 'GET_IATA_CODES_SUCCESS',
  GET_IATA_CODES_FAILURE: 'GET_IATA_CODES_FAILURE',
  GET_ALL_IATA_CODES_REQUEST: 'GET_ALL_IATA_CODES_REQUEST',
  GET_ALL_IATA_CODES_SUCCESS: 'GET_ALL_IATA_CODES_SUCCESS',
  GET_ALL_IATA_CODES_FAILURE: 'GET_ALL_IATA_CODES_FAILURE',
  ADD_MANUAL_FLIGHT_REQUEST: 'ADD_MANUAL_FLIGHT_REQUEST',
  ADD_MANUAL_FLIGHT_SUCCESS: 'ADD_MANUAL_FLIGHT_SUCCESS',
  ADD_MANUAL_FLIGHT_FAILURE: 'ADD_MANUAL_FLIGHT_FAILURE',
  EDIT_MANUAL_FLIGHT_REQUEST: 'EDIT_MANUAL_FLIGHT_REQUEST',
  EDIT_MANUAL_FLIGHT_SUCCESS: 'EDIT_MANUAL_FLIGHT_SUCCESS',
  EDIT_MANUAL_FLIGHT_FAILURE: 'EDIT_MANUAL_FLIGHT_FAILURE',
  DELETE_FLIGHT_REQUEST: 'DELETE_FLIGHT_REQUEST',
  DELETE_FLIGHT_SUCCESS: 'DELETE_FLIGHT_SUCCESS',
  DELETE_FLIGHT_FAILURE: 'DELETE_FLIGHT_FAILURE',
  CLEAR_IATA: 'CLEAR_IATA',
  GET_MANUAL_FLIGHT_REQUEST: 'GET_MANUAL_FLIGHT_REQUEST',
  GET_MANUAL_FLIGHT_SUCCESS: 'GET_MANUAL_FLIGHT_SUCCESS',
  GET_MANUAL_FLIGHT_FAILURE: 'GET_MANUAL_FLIGHT_FAILURE',
  CLEAR_MANUAL_FLIGHT: 'CLEAR_MANUAL_FLIGHT',
};
